import React from 'react';
import './Overview.css';

function OverviewPL() {
  return (
    <div className="section-container">
      {/* Main heading and subtitle */}
      <h2 className="main-heading">
        Przegląd <span className="heading-subtitle">Podsumowanie Projektu</span>
      </h2>

      {/* Client / Sector / Role / Time / Tools */}
      <div className="project-info">
        <div className="info-row">
          <div className="info-label">Klient:</div>
          <div className="info-value">Siemens Digital Logistics</div>
        </div>
        <div className="info-row">
          <div className="info-label">Sektor:</div>
          <div className="info-value">Logistyka, Software as a Service (SaaS)</div>
        </div>
        <div className="info-row">
          <div className="info-label">Moja rola:</div>
          <div className="info-value">UX Designer, UX Researcher, UI Designer</div>
        </div>
        <div className="info-row">
          <div className="info-label">Czas:</div>
          <div className="info-value"><span className="blue-text">5 lat</span></div>
        </div>
        <div className="info-row">
          <div className="info-label">Narzędzia:</div>
          <div className="info-value">Figma, Adobe, Jira, Confluence</div>
        </div>
      </div>

      {/* Intro Paragraphs */}
      <p style={{ marginBottom: '1rem' }}>
        Jako <strong>UX/UI designer</strong>, pracuję nad logistics platform i supply chain management, która została pierwotnie opracowana 20 lat temu, aby optymalizować i usprawniać procesy transportowe i logistyczne.
      </p>
      <p>
        Platforma oferuje cloud-based solution do współpracy, wymiany danych i zarządzania procesami między partnerami łańcucha dostaw. <strong>Najbardziej wiodące firmy na świecie</strong> używają tego logistics software na dużą skalę. To Software as a Service (SaaS) pozwala 500 000 użytkownikom zarządzać ich supply chains.
      </p>
      {/* Key Features */}
      <h3 className="subheading-blue">
        Kluczowe funkcje tej aplikacji:
      </h3>
      <ul className="list">
        <li><strong>Shipment tracking:</strong> Widoczność przesyłek i dostaw w czasie rzeczywistym.</li>
        <li><strong>Document management:</strong> Scentralizowany dostęp do dokumentów transportowych i danych.</li>
        <li><strong>Process automation:</strong> Automatyzuje przepływy pracy logistycznej w celu poprawy wydajności.</li>
        <li><strong>Collaboration tools:</strong> Ułatwia komunikację między dostawcami, przewoźnikami i klientami.</li>
        <li><strong>Integration capabilities:</strong> Łączy się z innymi systemami, takimi jak ERP, TMS i WMS.</li>
      </ul>
    </div>
  );
}

export default OverviewPL; 